var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgGoodstack = function SvgGoodstack(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3853_2014)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.959999C0 0.429806 0.429807 0 0.96 0H47.04C47.5702 0 48 0.429807 48 0.96V47.04C48 47.5702 47.5702 48 47.04 48H0.959999C0.429806 48 0 47.5702 0 47.04V0.959999Z",
    fill: "#8B4AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 21.4314C17.3769 21.4314 12 16.3451 12 10.08H17.822C17.822 13.2968 20.5994 15.9241 24 15.9241C27.4006 15.9241 30.178 13.2968 30.178 10.08H36C36 16.3283 30.6232 21.4314 24 21.4314Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 24.1765H12V29.6838H36V24.1765Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 32.429H12V37.9363H36V32.429Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3853_2014"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 4,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGoodstack);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "goodstack.54a454cf3d82562d39b57f73ba9f01fe.svg";